import { render, staticRenderFns } from "./myMultiSelect.vue?vue&type=template&id=2aedcb8a&"
import script from "./myMultiSelect.vue?vue&type=script&lang=js&"
export * from "./myMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports